import { Theme } from '@mui/material/styles';

export default function SvgIcon(theme: Theme) {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeSmall: {
          // width: 18,
          // height: 18,
          fontSize: '18px',
        },
        fontSizeMedium: {
          // width: 22,
          // height: 22,
          fontSize: '22px',
        },
        fontSizeLarge: {
          // width: 32,
          // height: 32,
          fontSize: '32px',
        },
      },
    },
  };
}
